import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-16d180fa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "inner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_FeatureCard = _resolveComponent("FeatureCard");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, {
    type: "flex",
    justify: "center",
    align: "middle",
    gutter: [20, 0]
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_FeatureCard, {
            icon: _ctx.IconPng1,
            title: "为什么选择编程",
            desc: "提升思维能力",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.linkItem('WhyLearnProgram');
            })
          }, null, 8, ["icon"])];
        }),
        _: 1
      }), _createVNode(_component_a_col, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_FeatureCard, {
            icon: _ctx.IconPng3,
            title: "优秀作品展示",
            desc: "历届活动优秀作品展示",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.linkItem('UserExcellent');
            })
          }, null, 8, ["icon"])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}